import { CopyText } from '../i18n/Language';
import { localizeUrl, LanguageSwitch, useLanguage } from '../i18n/Language';
import ArrowIcon from './ArrowIcon';
import { useLocation } from 'react-router-dom';
import { Link, NavLink } from '../i18n/Language';
import { useEffect } from 'react';
import { appsUrl } from '../data/studio';
export default function Header() {
  const { t, language } = useLanguage();
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return <header className="studio-header"><div className="studio-container header-inner">
    <Link to="/" className="wordmark" aria-label={t("Liminality home")}><img className="brand-symbol" src="/images/liminality-mark-alt.png" alt="" />LIMINALITY<span className="studio-word">STUDIO</span></Link>
    <nav aria-label={t("Main navigation")}><NavLink to="/" end>Studio</NavLink><NavLink to="/journal"><CopyText source={"Journal"} /></NavLink><a href={localizeUrl(appsUrl, language)}><CopyText source={"Apps"} /></a><Link className="nav-contact" to="/contact"><CopyText source={"Let’s talk"} />{' '}<ArrowIcon /></Link></nav><LanguageSwitch />
  </div></header>;
}
